import { render } from "./MemberBirthday.vue?vue&type=template&id=bfa16598&scoped=true"
import script from "./MemberBirthday.vue?vue&type=script&lang=js"
export * from "./MemberBirthday.vue?vue&type=script&lang=js"

import "./MemberBirthday.vue?vue&type=style&index=0&id=bfa16598&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa16598"]])

export default __exports__